// extracted by mini-css-extract-plugin
export default {"breadcrumbSelectSearchInput":"BreadCrumbActions_breadcrumbSelectSearchInput__IU7wP","breadcrumbText":"BreadCrumbActions_breadcrumbText__rVeK1"};